import {RootStoreState} from '../../../stores/RootStoreState';

export const getActualSubscriptionPlanId = (state: RootStoreState): string | undefined => {
  return state.isOneTimePurchase ? undefined : state.subscriptionInput;
};
